import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { EntityResource } from "./entity-resource";
import { ListResource } from "./list-resource";

@JsonObject()
export class EntityListResource extends ListResource<EntityResource> {
    @JsonProperty("items")
    @JsonElementType(EntityResource)
    items: Array<EntityResource>;
}
